var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloseNav = function SvgCloseNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17294D",
    d: "m2.997 1.444 24.968 24.968-1.56 1.56L1.437 3.004z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#17294D",
    d: "M.79 25.72 25.756.752l1.56 1.56L2.35 27.28z"
  })));
};

export { SvgCloseNav as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMi45OTczMSIgeT0iMS40NDQzNCIgd2lkdGg9IjM1LjMxMDMiIGhlaWdodD0iMi4yMDY5IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAyLjk5NzMxIDEuNDQ0MzQpIiBmaWxsPSIjMTcyOTREIi8+CjxyZWN0IHg9IjAuNzg4ODE4IiB5PSIyNS43MTk3IiB3aWR0aD0iMzUuMzEwMyIgaGVpZ2h0PSIyLjIwNjkiIHRyYW5zZm9ybT0icm90YXRlKC00NSAwLjc4ODgxOCAyNS43MTk3KSIgZmlsbD0iIzE3Mjk0RCIvPgo8L3N2Zz4K";